import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["discountType", "title", "amount", "prefix", "suffix", "discountCodes", "message", "submit"]

  connect() {
    console.log("Discount Form Controller connected");
    this.updateAmountFieldDisplay();
    this.validateForm();
  }

  updateAmountFieldDisplay() {
    if (this.discountTypeTarget.value === "percentage") {
      this.amountTarget.placeholder = "Enter discount %";
      this.amountTarget.step = "1"; // Only integers
      this.amountTarget.max = "100"; // Prevent values over 100
      this.prefixTarget.textContent = "";  // No prefix
      this.suffixTarget.textContent = "%";   // Suffix for percentage
    } else if (this.discountTypeTarget.value === "amount") {
      this.amountTarget.placeholder = "Enter amount in dollars";
      this.amountTarget.step = "0.01"; // Dollars with cents
      this.amountTarget.removeAttribute("max"); // No maximum
      this.prefixTarget.textContent = "$";   // Dollar sign as prefix
      this.suffixTarget.textContent = "";      // No suffix
    } else {
      this.amountTarget.placeholder = "Enter discount value";
      this.prefixTarget.textContent = "";
      this.suffixTarget.textContent = "";
    }
  }

  validateForm() {
    // Ensure the field attributes are updated according to the discount type.
    this.updateAmountFieldDisplay();

    const discountTypeValid = this.discountTypeTarget.value !== "";
    const titleValid = this.titleTarget.value.trim() !== "";
    const amountValue = this.amountTarget.value.trim();
    let amountValid = amountValue !== "" && Number(amountValue) > 0;

    // Additional check for percentage type: value should not exceed 100.
    if (this.discountTypeTarget.value === "percentage" && Number(amountValue) > 100) {
      amountValid = false;
    }

    // Validate that at least one discount code input has a non-empty value.
    const discountCodeInputs = this.discountCodesTarget.querySelectorAll(".discount-code-input");
    let discountCodeValid = false;
    discountCodeInputs.forEach(input => {
      if (input.value.trim() !== "") {
        discountCodeValid = true;
      }
    });

    let message = "";
    if (!discountTypeValid) {
      message += "Please select a discount type. ";
    }
    if (!titleValid) {
      message += "Please enter a title. ";
    }
    if (!amountValid) {
      if (this.discountTypeTarget.value === "percentage" && Number(amountValue) > 100) {
        message += "Percentage discount cannot be over 100. ";
      } else {
        message += "Please enter a valid discount value greater than 0. ";
      }
    }
    if (!discountCodeValid) {
      message += "At least one active discount code is required. ";
    }

    // Update the message element with our validation message.
    this.messageTarget.textContent = message;

    // Toggle visibility of the info-box container based on the message content.
    const infoBox = this.messageTarget.closest('.info-box');
    if (message.trim() === "") {
      infoBox.classList.add("hidden");
    } else {
      infoBox.classList.remove("hidden");
    }

    // Update the message element's classes for valid/error states.
    if (message.trim() === "") {
      this.messageTarget.classList.remove("error");
      this.messageTarget.classList.add("valid");
    } else {
      this.messageTarget.classList.remove("valid");
      this.messageTarget.classList.add("error");
    }

    // Enable or disable the submit button based on overall form validity.
    this.submitTarget.disabled = !(discountTypeValid && titleValid && amountValid && discountCodeValid);
  }
}
